function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M13 25c6.892 0 12.5-5.608 12.5-12.5S19.892 0 13 0 .5 5.608.5 12.5 6.108 25 13 25zm.305-23.17c5.716 0 10.366 4.65 10.366 10.365h-.83c0-5.258-4.277-9.536-9.536-9.536v-.83zm-.61 2.438c4.707 0 8.537 3.83 8.537 8.537h-.854c0-4.236-3.447-7.683-7.683-7.683v-.854zm.61 1.83a6.104 6.104 0 0 1 6.097 6.097h-.813a5.29 5.29 0 0 0-5.284-5.284v-.813zm0 3.048a3.052 3.052 0 0 1 3.049 3.05 3.052 3.052 0 0 1-3.05 3.048 3.052 3.052 0 0 1-3.048-3.049 3.052 3.052 0 0 1 3.049-3.049zM7.41 12.805a5.29 5.29 0 0 0 5.284 5.284v.813a6.104 6.104 0 0 1-6.097-6.097h.813zm-1.789-.61c0 4.236 3.447 7.683 7.683 7.683v.854c-4.707 0-8.537-3.83-8.537-8.537h.854zm-1.854 0c0 5.259 4.278 9.537 9.537 9.537v.829c-5.716 0-10.366-4.65-10.366-10.366h.83z"
});

var SvgDisk = function SvgDisk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disk.c073f0b7.svg";
export { ForwardRef as ReactComponent };